import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { AuthService } from '../../services/auth.service';
import { WebsiteThemeService } from './../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebClientService } from './../../services/webclient-settings.service';
import { ActivatedRoute } from '@angular/router';
;
/**
 * Contact Component
 */
let ContactComponent = class ContactComponent {
    constructor(httpClient, auth, sanitizer, themeService, webSettingsService, activated) {
        this.httpClient = httpClient;
        this.auth = auth;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.activated = activated;
        this.contact = {};
        this.sent = false;
        this.any = {};
        this.secondColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.textColor = '';
        this.successColor = '';
        this.errorColor = '';
        this.idSelected = '9999';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.mainColor = '';
        this.emailError = false;
        this.firstError = false;
        this.lastError = false;
        localStorage.removeItem('data');
        this.setLanguage();
    }
    ngOnInit() {
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
        });
        if (this.auth.isAuthenticated()) {
            this.auth.fetchUser().then(() => {
                this.userData = JSON.parse(localStorage.getItem('user'));
                if (this.userData) {
                    this.contact.email = this.userData.email;
                    this.contact.name = this.userData.name.substring(0, this.userData.name.indexOf(' '));
                    this.contact.first = this.userData.name.substring(0, this.userData.name.indexOf(' '));
                    this.contact.last = this.userData.name.substring(this.userData.name.indexOf(' ') + 1, this.userData.name.length);
                }
            });
        }
        this.httpClient.get('contactform/subjects').subscribe((data) => {
            this.subjects = Object.values(data);
            this.contact.subject_id = 9999;
            this.activated.queryParams.subscribe((params) => {
                const area = params['area'];
                if (area) {
                    this.idSelected = area;
                    for (let iterator = 0; iterator < this.subjects.length; iterator++) {
                        if (parseInt(this.idSelected) === this.subjects[iterator].id) {
                            this.contact.subject_id = parseInt(this.idSelected) !== undefined ? parseInt(this.idSelected) : 9999;
                            break;
                        }
                    }
                }
            });
        });
    }
    submit() {
        this.contact.name = '';
        this.checkEmail();
        this.checkFirst();
        this.checkLast();
        this.addLanguageToFormData();
        if (this.contact.subject_id === 9999) {
            this.selectError = true;
        }
        else {
            this.selectError = false;
        }
        if (!this.selectError && !this.emailError && !this.firstError && !this.lastError) {
            this.contact.name = this.contact.first + ' ' + this.contact.last;
            this.httpClient.post('contactform/submit', this.contact).subscribe((data) => {
                this.sent = true;
            }, (error) => {
            });
        }
    }
    checkEmail() {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        if (reg.test(this.contact.email) === false && this.contact.email) {
            this.emailError = true;
            return false;
        }
        else {
            this.emailError = false;
            return true;
        }
    }
    checkFirst() {
        if (this.contact.first) {
            let first = this.contact.first.trim();
            if (first.length < 2) {
                this.firstError = true;
            }
            else {
                this.firstError = false;
            }
        }
    }
    checkLast() {
        if (this.contact.last) {
            let last = this.contact.last.trim();
            if (last.length < 2) {
                this.lastError = true;
            }
            else {
                this.lastError = false;
            }
        }
    }
    addLanguageToFormData() {
        this.contact.language = this.lang;
    }
    setLanguage() {
        this.webSettingsService.getSettings().subscribe((data) => {
            if (this.lang === null || this.lang === undefined || this.lang === '') {
                var currentLanguage = this.webSettingsService.getCurrentLanguage();
                var defaultLanguage = this.webSettingsService.getDefaultLanguage();
                if (currentLanguage === null || currentLanguage === undefined || currentLanguage === '') {
                    this.lang = defaultLanguage;
                }
                else {
                    this.lang = currentLanguage;
                }
                if (this.lang === null || this.lang === undefined || this.lang === '') {
                    this.lang = 'sr';
                }
            }
        });
    }
};
ContactComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: AuthService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: ActivatedRoute }
];
ContactComponent = __decorate([
    Component({
        selector: 'ecd-contact',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./contact.component.html")).default
    })
], ContactComponent);
export { ContactComponent };
